import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Videos } from "@/components/site/Videos";
import { Streaming } from "@/components/site/Streaming";
import { Music } from "@/components/site/Music";
import { Songs } from "@/components/site/Songs";
import { Gallery } from "@/components/site/Gallery";
import { Label } from "@/components/site/Label";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { useContent } from "@/hooks/useContent";
import { mergePlatforms } from "@/data/site";

export default function Home() {
  const { links, upcoming, videos, songs, photos } = useContent();
  const platforms = mergePlatforms(links);
  const yt = platforms[0].url;
  return (
    <div className="grain">
      <SmoothScroll />
      <Nav />
      <main>
        <Hero latestTitle={videos[0]?.title} />
        <Marquee />
        <Videos videos={videos} channelUrl={yt} />
        <Streaming platforms={platforms} />
        <Music latest={videos[0]} upcoming={upcoming} />
        <Songs songs={songs} />
        <Gallery photos={photos} />
        <Label />
        <Contact />
      </main>
      <Footer platforms={platforms} links={links} />
    </div>
  );
}
